import React from 'react';
import { Brain, Heart, Globe, Shield, AlertCircle } from 'lucide-react';
import { trainingTopics } from '../mock';

const TrainingSection = () => {
  const iconMap = {
    Brain: Brain,
    Heart: Heart,
    Globe: Globe,
    Shield: Shield,
    AlertCircle: AlertCircle
  };

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative order-2 md:order-1">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1521737711867-e3b97375f902"
                alt="Professional driver training"
                className="w-full h-[500px] object-cover"
              />
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -top-6 -right-6 p-6 rounded-2xl backdrop-blur-xl bg-[#2ECC71] shadow-2xl border-4 border-white">
              <p className="text-white font-bold text-lg text-center">
                Certified<br />Training
              </p>
            </div>
          </div>

          {/* Content Side */}
          <div className="order-1 md:order-2">
            <h2 className="text-5xl font-bold text-[#0B0F14] mb-6">
              Built on Training.<br />Driven by Empathy.
            </h2>
            
            <div className="space-y-4 mb-8">
              {trainingTopics.map((topic, index) => {
                const Icon = iconMap[topic.icon];
                return (
                  <div 
                    key={index}
                    className="flex items-center gap-4 p-5 rounded-2xl bg-gradient-to-r from-[#F7F9FB] to-white border border-gray-200 hover:border-[#0077BE] hover:shadow-lg transition-all duration-300 group"
                  >
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#0077BE] to-[#00B4D8] flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <p className="text-lg font-semibold text-[#0B0F14]">
                      {topic.text}
                    </p>
                  </div>
                );
              })}
            </div>

            {/* Callout */}
            <div className="p-8 rounded-2xl bg-gradient-to-br from-[#0077BE] to-[#00B4D8] text-white">
              <p className="text-2xl font-bold italic text-center">
                "We hire for character. We train for excellence."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrainingSection;
